import React from 'react';
import { connect } from 'react-redux';
import { getTitleFromBreadcrumb } from '@nykaa/seo/utils';
import { State } from 'store/types';
import View from './View';
import SeoView from './SeoView';
import { CategoryItem } from 'store/footer/types';
import { PriceList as PriceListType } from 'store/footer/types';

export interface PriceListProps {
  list?: PriceListType;
  pageType: string;
  Bestsellers?: CategoryItem[];
  title?: string;
  isSeoFooterApiEnable?: boolean;
}

const renderComponent = ({ isSeoFooterApiEnable, ...props }: PriceListProps) =>
  isSeoFooterApiEnable ? <SeoView {...props} /> : <View {...props} />;

const mapStateToProps = (state: State) => {
  const { footer, appReducer, remoteConfig } = state;
  const {
    switches: { seoFooterCategoryEnable },
  } = remoteConfig;
  const { breadCrumb } = appReducer;
  const title = getTitleFromBreadcrumb(breadCrumb);

  return {
    title,
    list: footer?.priceList || {},
    Bestsellers: footer?.categories?.Bestsellers?.slice(0, 5) || [],
    pageType: appReducer?.pageType,
    isSeoFooterApiEnable: seoFooterCategoryEnable,
  };
};

export default connect(mapStateToProps)(renderComponent);
